var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mt-16",
    attrs: {
      "max-width": "700",
      "width": "100%"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "text-h5 font-weight-bold"
  }, [_vm._v("Location")])], 1), _c('img', {
    staticClass: "map-img rounded-lg mt-2",
    attrs: {
      "alt": "google map location of building",
      "src": "https://media.eipl.org/site/images/site/location-map.png"
    }
  }), _c('v-card-text', {
    staticClass: "card-text primary--text"
  }, [_c('v-sheet', {
    staticClass: "d-flex flex-row flex-wrap justify-space-between px-0",
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-sheet', {
    staticClass: "text-no-wrap",
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-subheader', {
    staticClass: "primary--text font-weight-bold pa-0"
  }, [_vm._v("Address:")]), _c('p', {
    staticClass: "text-h5 primary--text mb-0"
  }, [_vm._v("381 East Main Street")]), _c('p', {
    staticClass: "text-h5 primary--text mb-0"
  }, [_vm._v("East Islip, NY 11730")])], 1), _c('v-btn', {
    staticClass: "align-self-end",
    attrs: {
      "href": "https://www.google.com/maps/dir//40.735218,-73.172244/@40.7351968,-73.2422839,12z/data=!4m4!4m3!1m0!1m1!4e1?hl=en",
      "color": "primary",
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-google-maps")]), _vm._v("Google Maps ")], 1)], 1), _c('v-card', {
    staticClass: "pt-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "d-flex flex-row justify-space-between px-0"
  }, [_c('h5', {
    staticClass: "text-h5 font-weight-bold primary--text"
  }, [_vm._v("Directions")])]), _c('v-card-text', {
    staticClass: "primary--text px-0"
  }, [_c('h6', {
    staticClass: "text-h6"
  }, [_vm._v("From the West:")]), _c('v-subheader', {
    staticClass: "primary--text font-weight-bold pa-0"
  }, [_vm._v("Northern State Parkway or Long Island Expressway:")]), _c('p', [_vm._v(" East to Sagtikos Parkway. Sagtikos Parkway South to Southern State Parkway (bear left at junction). Southern State Parkway East (bear right) to exit 45 West (Montauk Highway). Entrance to the library’s side parking lot is directly across from parkway exit ramp (behind the church). ")]), _c('v-subheader', {
    staticClass: "primary--text font-weight-bold pa-0"
  }, [_vm._v("Sunrise Highway:")]), _c('p', [_vm._v(" East to exit 46 (Carleton Avenue Exit). Continue on the service road past Carleton (bear right) to Heckscher State Parkway South. Heckscher State Parkway to exit 45 West (Montauk Highway) Entrance to the library’s side parking lot is directly across from parkway exit ramp (behind the church). ")])], 1), _c('v-card-text', {
    staticClass: "primary--text px-0"
  }, [_c('h6', {
    staticClass: "text-h6"
  }, [_vm._v("From the East:")]), _c('v-subheader', {
    staticClass: "primary--text font-weight-bold pa-0"
  }, [_vm._v("Montauk Highway:")]), _c('p', [_vm._v(" East past Route 111 (Islip Avenue), Irish Lane (H20 restaurant) and Carleton Avenue (CVS Shopping Center). Proceed East on Montauk Highway past Pat's Market Place shopping center on the right. ")]), _c('v-subheader', {
    staticClass: "primary--text font-weight-bold pa-0"
  }, [_vm._v("Sunrise Highway:")]), _c('p', [_vm._v(" West to the Exit 46 Southern State Parkway South (Hecksher Parkway).Continue on the service road past Connetquot Avenue to Heckscher State Parkway South. Heckscher State Parkway to exit 45 West (Montauk Highway). Entrance to the Library’s side parking lot is directly across from the parkway exit ramp. (behind the church). ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }